export const SWAGSTORE_STEPS = {
  STORE_DETAILS: "store-details",
  BRANDING: "branding",
  LOGIN: "login",
  PRODUCT_MAPPING: "product-mapping",
  MOCKUPS: "mockups",
} as const;

export type SwagstoreStep =
  (typeof SWAGSTORE_STEPS)[keyof typeof SWAGSTORE_STEPS];

export const SWAGSTORE_STEP_VALUES = Object.values(
  SWAGSTORE_STEPS,
) as readonly string[];
